module.exports = __webpack_public_path__ + "static/media/fightscout_bkfc.c26d84a5.png";